import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// import { Modal } from 'bootstrap';
import CustomerForm, {
  CustomerFormFields,
} from '../../components/Customer/CustomerForm';
import { useAuth } from '../../contexts/auth';
import PersonType from '../../enums/PersonType';
import api from '../../services/api';
import {
  PersonAddresses,
  PersonAdressFormFields,
  PersonAdressModel,
} from '../../components/Person/PersonAddresses';
import EquipmentsIndex from '../equipments/EquipmentsIndex';
import EstimatesIndex from '../estimates/EstimatesIndex';
import CustomersEstimates from './CustomersEstimates';
import CustomersInvoices from './CustomersInvoices';

export default function CustomersEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [addressUpdateIsLoading, setAddressUpdateIsLoading] = useState(false);
  const [isAddressesLoading, setIsAddressesLoading] = useState(false);
  const [addresses, setAddresses] = useState<PersonAdressModel[]>([]);

  const [formFields, setFormFields] = useState<CustomerFormFields>(
    null as unknown as CustomerFormFields
  );
  const [formErrors, setFormErrors] = useState({});
  const [formAddressErrors, setAddressErrors] = useState({});

  const [addressFormFields, setAddressFormFields] =
    useState<PersonAdressFormFields>(null as unknown as PersonAdressFormFields);

  async function getCustomer() {
    if (organization && id) {
      const { data } = await api.get(
        `organizations/${organization.id}/customers/${id}`
      );

      setFormFields({
        type: data.type,
        identifier: data.identifier,
        name: data.name,
        alias: data.alias,
        useAlias: data.useAlias,
        email: data.email,
        phone: data.phone,
      });
      setIsLoading(false);
    }
  }

  async function getAddresses() {
    if (organization) {
      setIsAddressesLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/customers/${id}/addresses`
      );
      setAddresses(response.data.data);
      setIsAddressesLoading(false);
    }
  }

  const onSubmit = async (data: CustomerFormFields) => {
    try {
      await api.put(`organizations/${organization.id}/customers/${id}`, {
        alias:
          Number(data.type) === PersonType.Juridical ? data.alias : undefined,
        ...data,
      });

      navigate('/customers');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const setAddressFields = (data: any) => {
    setAddressFormFields({
      id: data.id,
      address: data.address,
      number: data.number,
      complement: data.complement,
      neighborhood: data.neighborhood,
      city: data.city,
      state: data.state,
      postalCode: data.postalCode,
    });
  };

  const onSubmitAddress = async (data: PersonAdressFormFields) => {
    try {
      const { id: addressId, ...address } = data;
      let response;
      if (data.id) {
        response = await api.put(
          `organizations/${organization.id}/customers/${id}/addresses/${addressId}`,
          address
        );
      } else {
        response = await api.post(
          `organizations/${organization.id}/customers/${id}/addresses`,
          address
        );
      }
      setAddressFields(response.data);
      toast.success('Endereço salvo');
      getAddresses();
    } catch (e: any) {
      if (e?.response?.data?.errors) {
        if (e?.response?.status === 422) {
          setAddressErrors(e.response.data.errors);
        } else {
          toast.error(
            e?.response?.data?.errors.reduce(
              (acc: string, error: string) => acc + error,
              ''
            )
          );
        }
      } else {
        throw e;
      }
    }
  };

  const editAddress = async (addressId: number) => {
    try {
      setAddressUpdateIsLoading(true);
      const { data } = await api.get(
        `organizations/${organization.id}/customers/${id}/addresses/${addressId}`
      );
      setAddressFields(data);
    } catch (e: any) {
      toast.error(
        e?.response?.data?.errors.reduce(
          (acc: string, error: string) => acc + error,
          ''
        )
      );
    } finally {
      setAddressUpdateIsLoading(false);
    }
  };

  const removeAddress = useCallback(
    async (address: PersonAdressModel) => {
      try {
        const displayName = `${address.address}, ${address.number}`;
        if (
          // eslint-disable-next-line no-restricted-globals
          confirm(
            `Você tem certeza que deseja remover o endereço "${displayName}"? Essa ação não poderá ser desfeita.`
          )
        ) {
          await api.delete(
            `organizations/${organization.id}/customers/${id}/addresses/${address.id}`
          );
          getAddresses();
          toast.success(`O endereço "${displayName}" foi removido do Cliente`);
        }
      } catch (e) {
        // TODO: Recarregar lista
        toast.error(
          'Houve um problema ao tentar remover o endereço do Cliente. Tente novamente.'
        );
      }
    },
    [organization.id, id]
  );

  useEffect(() => {
    getCustomer();
    getAddresses();
  }, [organization, id]);

  return (
    <>
      <ul className='nav nav-tabs'>
        <li className='nav-item'>
          <button
            type='button'
            className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
            aria-current='page'
            onClick={() => setActiveTab(0)}
          >
            Dados
          </button>
        </li>
        <li className='nav-item '>
          <button
            type='button'
            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
            onClick={() => setActiveTab(1)}
          >
            Endereços
          </button>
        </li>
        <li className='nav-item '>
          <button
            type='button'
            className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
            onClick={() => setActiveTab(2)}
          >
            Equipamentos
          </button>
        </li>
        <li className='nav-item '>
          <button
            type='button'
            className={`nav-link ${activeTab === 3 ? 'active' : ''}`}
            onClick={() => setActiveTab(3)}
          >
            Orçamentos
          </button>
        </li>
        <li className='nav-item '>
          <button
            type='button'
            className={`nav-link ${activeTab === 4 ? 'active' : ''}`}
            onClick={() => setActiveTab(4)}
          >
            Ordens de Serviço
          </button>
        </li>
      </ul>
      {activeTab === 0 && (
        <CustomerForm
          isUpdate
          isLoading={isLoading}
          title={`Editar Cliente ${id}`}
          formFields={formFields}
          formErrors={formErrors}
          onSubmit={onSubmit}
        />
      )}

      {activeTab === 1 && (
        <PersonAddresses
          itens={addresses}
          onSubmitAddress={onSubmitAddress}
          removeAddress={removeAddress}
          editAddress={editAddress}
          formErrors={formAddressErrors}
          formFields={addressFormFields}
          isUpdateLoading={addressUpdateIsLoading}
        />
      )}

      {activeTab === 2 && <EquipmentsIndex customerId={Number(id)} />}
      {activeTab === 3 && <CustomersEstimates customerId={Number(id)} />}
      {activeTab === 4 && <CustomersInvoices customerId={Number(id)} />}
    </>
  );
}
